import React from "react";
import { FormikErrors, FormikHelpers, FormikTouched } from "formik";
import { CardholderPageModel } from "./types";
import { ProductRefType } from "../../context/product-context/types";
import { CardholderModel } from "./cardholder-form/types";
import { BasicAccountApplicationDocument } from "../../api/commercial/generated-types";

export interface CardholderContextProp {
  selectedProduct: ProductRefType;
  companyName: string;
  isSoleProprietorship: boolean;
  adminData?: CardholderModel;
  hasDecentralizedInvoicing: BasicAccountApplicationDocument["hasDecentralizedInvoicing"];
  limit: number;
}

export const CardholderFormikContext = React.createContext<{
  touched: FormikTouched<CardholderPageModel>;
  errors: FormikErrors<CardholderPageModel>;
  values: CardholderPageModel;
  setFieldValue: FormikHelpers<CardholderPageModel>["setFieldValue"];
}>(undefined);
